import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgArchitectuur = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M22 8h-4v2h-2v3.826h-3v3.826h-3V32h20V17.652h-3v-3.826h-3V10h-2z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M18 23h-5v9h5z"
    />
    <circle
      cx={23.5}
      cy={21.5}
      r={2.5}
      fill="#00C5F2"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgArchitectuur);

export default ForwardRef;
